import React from "react";
import { filter, get, last, map } from "lodash";
import UploadedFile from "components/shared/fields/fileUploadField/UploadedFile";
import { useDispatch } from "react-redux";

export default function FileAttachments({
  files,
  chatId,
}: {
  files: File[];
  chatId: string;
}) {
  const dispatch = useDispatch();

  function remove({ id }) {
    dispatch({
      type: "chat/COMPOSER/SET_FILE_ATTACHMENTS",
      chatId,
      fileAttachments: filter(files, (file) => get(file, "id") !== id),
    });
  }

  return (
    <div className="grid grid-cols-1 divide-y divide-white bg-white px-2 py-2 rounded">
      {map(files, (file, index) => (
        <UploadedFile
          key={index}
          file={{
            progress: 100,
            ...file,
            extension: last(file.name.split(".")) || "",
          }}
          remove={remove}
        />
      ))}
    </div>
  );
}
